<template>
  <div class="phone-country">
    <select v-model="model" aria-label="Pays" name="pets">
      <option v-for="c in countriesWithLabel" :key="c.code" :value="c.code">
        {{ c.label }}
      </option>
    </select>

    <div class="country-selector" aria-hidden="true">
      <span class="flag">{{ isoToEmoji(model) }}</span>
      <icon size="2rem" name="unrollContent" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { getCountries, type CountryCode } from 'libphonenumber-js';
import countriesFrench from '~/assets/data/iso-3166_country_french.json';

const model = defineModel<CountryCode>('country', { default: 'FR' });
const isoToEmoji = (code) => {
  return code
    .split('')
    .map((letter) => (letter.charCodeAt(0) % 32) + 0x1f1e5)
    .map((emojiCode) => String.fromCodePoint(emojiCode))
    .join('');
};
const countriesWithLabel = computed(() => {
  const countries = getCountries();
  const lCountries = [];
  countries.forEach((countryCode) => {
    lCountries.push({
      code: countryCode,
      label: countriesFrench[countryCode],
    });
  });
  lCountries.sort(function (a, b) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });
  return lCountries;
});
</script>
<style lang="scss" scoped>
.phone-country {
  position: relative;
}
.country-selector {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: var(--gap_xs);
  .flag {
    font-size: 3.2rem;
    line-height: 3.2rem;
  }
  &::after {
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0.4rem;
    border-radius: 0.2rem;
    background-color: var(--color_primary);
  }
}
select {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 0;
  border-radius: 2rem;
  opacity: 0;
  cursor: pointer;

  &:hover,
  &:focus {
    ~ .country-selector {
      &::after {
        content: '';
      }
    }
  }
}
</style>
